export enum Hosting {
  CLOUD = "cloud",
  SELF = "self",
}
